import React, { useEffect, useState } from "react";
import "./style.css";

const BackToTopButton = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => setVisible(window.scrollY > 220);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollUp = () => window.scrollTo({ top: 0, behavior: "smooth" });

  if (!visible) return null;

  return (
    <button
      className="floating-btn back-top-btn"
      onClick={scrollUp}
      title="Volver arriba"
    >
      <span className="back-top-arrow" />
    </button>
  );
};

export default BackToTopButton;
